// src/components/NavBar.js

import { Link } from 'react-router-dom';
import { Box, Flex, Button, Stack } from '@chakra-ui/react';
import { useAuth0 } from '@auth0/auth0-react';
import { useState, useEffect } from 'react';
import { auth0Config } from '../config/auth.config';

const NavBar = () => {
  const { user, isAuthenticated, getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const [isAdmin, setIsAdmin] = useState(false);
  
  useEffect(() => {
    const checkAdminRole = async () => {
      if (!isAuthenticated) {
        setIsAdmin(false);
        return;
      }
      
      try {
        // Try getting role from ID token claims first (these include custom claims)
        const idTokenClaims = await getIdTokenClaims();
        const roleFromIdToken = idTokenClaims?.['https://indexerglue.com/role'];
        
        if (roleFromIdToken === 'admin') {
          setIsAdmin(true);
          return;
        }
        
        // Fallback: Get the access token with audience to ensure custom claims
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: auth0Config.audience,
          }
        });
        
        // Decode JWT payload (middle part)
        const payload = JSON.parse(atob(token.split('.')[1]));
        const role = payload['https://indexerglue.com/role'];
        
        setIsAdmin(role === 'admin');
      } catch (error) {
        console.error('Error checking admin role:', error);
        setIsAdmin(false);
      }
    };
    
    checkAdminRole();
  }, [isAuthenticated, getAccessTokenSilently, getIdTokenClaims]);

  return (
    <Box bg="teal.500" px={3}>
      <Flex h={8} alignItems={'center'} justifyContent={'space-between'}>
        <Box color="white" fontWeight="bold">
          IndexerGlue
        </Box>
        <Stack direction={'row'} spacing={7}>
          <Button as={Link} to="/dashboard" variant="ghost" color="white">
            Dashboard
          </Button>
          <Button as={Link} to="/HowTo" variant="ghost" color="white">
            How-To Guide
          </Button>
          <Button as={Link} to="/apidocumentation" variant="ghost" color="white">
            API Documentation
          </Button>
          <Button as={Link} to="/accountinfo" variant="ghost" color="white">
            Account Info
          </Button>
          <Button as={Link} to="/stats" variant="ghost" color="white">
            Stats
          </Button>
          <Button as={Link} to="/docker" variant="ghost" color="white">
            Self-Host
          </Button>
          {isAdmin && (
            <Button as={Link} to="/admin" variant="ghost" color="yellow.200" fontWeight="bold">
              Admin
            </Button>
          )}
        </Stack>
      </Flex>
    </Box>
  );
};

export default NavBar;
